import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import {
  Container,
  Header,
  Left,
  Title,
  LoadingIcon,
  Content,
  ImportantHeader,
  TextConfirm,
  Item,
  InfoContainer,
  Button,
  ButtonContainer,
  Box,
  ItemContainer,
  ModalHeader,
} from './styles';
import { InfoButton } from '~/components/layout/Buttons';
import Botijao from '~/assets/images/botijao-p13-branco.svg';
import Answer2 from '~/components/pages/Logistic/OrderChecklist/Answer/Contents/2';
import Answer3 from '~/components/pages/Logistic/OrderChecklist/Answer/Contents/3';
import Answer4 from '~/components/pages/Logistic/OrderChecklist/Answer/Contents/4';
import Answer5 from '~/components/pages/Logistic/OrderChecklist/Answer/Contents/5';
import Answer6 from '~/components/pages/Logistic/OrderChecklist/Answer/Contents/6';
import caminhao from '~/assets/images/truck.png';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import OpenChatBot from '~/components/layout/Chatbot';


export default function OrderChecklist({ close }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [answerId, setAnswerId] = useState(null);
  const history = useHistory();
  const roles = useSelector(state => state.rolesReducer.roles);

  return (
    <Container className="background" disableScroll={showModal}>
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
        <>
          <Box disableScroll={showModal}>
            <Header>
              <Left>
                <img src={Botijao} />
                <Title>Pedido de Abastecimento</Title>
              </Left>
            </Header>
            <Content>
              <ImportantHeader>
                <img src={caminhao} />
                <span>Importante</span>
              </ImportantHeader>
              <TextConfirm>Confira condições de carregamento: </TextConfirm>
              <ItemContainer className="mt-3">
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>Documentação e apresentação do condutor</span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=2`);
                        } else {
                          setAnswerId('2');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>
                      Documentação do veículo e do produto transportado
                    </span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=3`);
                        } else {
                          setAnswerId('3');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>Conjunto de equipamentos para emergência e EPI</span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=4`);
                        } else {
                          setAnswerId('4');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>
                      Sinalização do veículo (Identificação de unidades de
                      transporte)
                    </span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=5`);
                        } else {
                          setAnswerId('5');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>
                      Estado de conservação do veículo e equipamentos
                      obrigatórios
                    </span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=6`);
                        } else {
                          setAnswerId('6');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>
                      Necessário apresentar a nota fiscal
                      impressa na retirada do seu pedido
                    </span>
                    <br />
                  </div>
                </Item>
              </ItemContainer>
              <InfoContainer>
                <i class="fa fa-exclamation-circle" aria-hidden="true" />
                <span>
                  O não atendimento a qualquer item deste check-list impede a
                  liberação do veículo para carregamento e transporte de
                  produtos perigosos.
                </span>
              </InfoContainer>
              <ButtonContainer>
                {loading ? (
                  <Button>
                    <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                  </Button>
                ) : (
                  <InfoButton style={{ width: '50%', marginTop: '2rem' }}  onClick={() => history.push('/lista-de-pedidos')}>
                    <div>OK, Entendi</div>
                  </InfoButton>
                 // <Button onClick={() => history.push('')}>OK, Entendi</Button>
                )}
              </ButtonContainer>
            </Content>
          </Box>
          <Modal
            animation={true}
            show={showModal}
            size="lg"
            centered
            onHide={() => setShowModal(false)}
          >
            <Modal.Body>
              <ModalHeader>
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  onClick={() => setShowModal(false)}
                />
              </ModalHeader>
              {answerId === '2' ? <Answer2 /> : null}
              {answerId === '3' ? <Answer3 /> : null}
              {answerId === '4' ? <Answer4 /> : null}
              {answerId === '5' ? <Answer5 /> : null}
              {answerId === '6' ? <Answer6 /> : null}
            </Modal.Body>
          </Modal>
        </>
      ) : (
        <Redirect to="/portal" />
      )}
      <OpenChatBot />
    </Container>
  );
}
